import { HoldScrollPagePosition } from "./HoldScrollPage";

export default {
  mounted(el, binding) {
    if (binding.value) lockScroll();
  },
  updated(el, binding) {
    if (binding.value) lockScroll();
    // else unlockScroll();
  },
  unmounted(el, binding) {
    const store = useLayoutStore();

    if (binding.value && !store.GET_ShowModal) unlockScroll();
  },
};

function hasScrollOnBody() {
  const bodyScrollHeight = document.body.scrollHeight;
  const viewportHeight = window.innerHeight;
  return bodyScrollHeight > viewportHeight;
}

function lockScroll() {
  document.body.classList.add("scrolllock");
  if (!hasScrollOnBody()) document.body.classList.add("no-scroll");
  HoldScrollPagePosition(true);
}

function unlockScroll() {
  document.body.classList.remove("scrolllock", "no-scroll");
  HoldScrollPagePosition(false);
}
